"use client";

// THE READING RAMP, from whatever scrolls (law_read_ramp on the stage).
//
// Every reading surface wrote the same thing: on a window scroll, the first
// ~200-320px of travel ramp the reading scrim and the seam's frost in, and
// rest the organism. On the stage the window no longer scrolls, so this hears
// the stage's scroller through the bus (lib/stage/scroller) — and the window on
// a page with no stage, so a surface can switch to it before or after it moves
// onto the stage. One writer, one cleanup.

import { useEffect } from "react";
import { onStageScroll, stageScrollTop } from "../../lib/stage/scroller";
import { clearReadRamp, writeReadRamp } from "../../lib/os/readRamp";
import { setOrganismCalm } from "../../lib/organism/calmBus";

export function useStageReadRamp(
  rampPx: number,
  prefix: "art" | "os" = "art",
  opts?: {
    /** false: leave the organism's rest to the caller (writeReadRamp's `calm`). */
    calm?: boolean;
    /** rest the organism by the ramp under this calm-bus key (the os surfaces). */
    calmKey?: string;
    /** the ramp restarts at the top whenever this changes (a new place). */
    key?: unknown;
    /** false: write nothing (and clear). */
    active?: boolean;
  },
): void {
  const active = opts?.active !== false;
  const calm = opts?.calm;
  const calmKey = opts?.calmKey;
  const key = opts?.key;
  useEffect(() => {
    if (!active) return;
    const write = () => {
      const v = Math.max(0, Math.min(1, stageScrollTop() / rampPx));
      const lv = writeReadRamp(v, prefix, calm === false ? { calm: false } : undefined);
      if (calmKey) setOrganismCalm(calmKey, lv);
    };
    write();
    const off = onStageScroll(write);
    return () => {
      off();
      clearReadRamp(prefix);
      if (calmKey) setOrganismCalm(calmKey, null);
    };
  }, [rampPx, prefix, calm, calmKey, key, active]);
}
